import { create } from 'zustand';

/**
 * NOTE: Not persisted on purpose, so the flag resets on the next page load. A persisted flag would also drop the
 * post-login target of a deep link opened after a logout.
 */

interface ExplicitLogoutState {
  /**
   * True after the user logged out on purpose, until the next page load, login attempt or failed logout.
   * MSAL removes the account while the logout is still running, so the protected page re-renders as logged out
   * and would keep itself as the post-login target. After an explicit logout, the next user should start fresh.
   * A logout after a failed token refresh is not marked, so the user returns to the same page.
   */
  explicitLogout: boolean;
  setExplicitLogout: (explicitLogout: boolean) => void;
}

export const useExplicitLogoutStore = create<ExplicitLogoutState>()((set) => ({
  explicitLogout: false,
  setExplicitLogout: (explicitLogout) => set({ explicitLogout }),
}));
